<template>
  <h1>Articles</h1>
</template>
